// 포인트 내역 한 줄의 제목·메모 — ★러닝앱(PointHistoryApi.cs)·트랩앱(app script/Common/PointLabel.js)과 같은 표다.
//   지갑(member_points)은 회원×클럽 하나라 러닝 코인·체육관 적립·회원권 결제·캐릭터 구매가 한 장부에 섞인다.
//   제목 = fcType 분류, 메모 = 보조 줄. 로스터: 110 꾸미기 구매(구 로커) · 111 캐릭터 구매 · 112 의상 구매(2026-10-08 신설).
//   ★옛 로스터 행 memo 는 내부 키다(locker:outfit:1:w04_s03 · locker:slot:2 · locker:skin:w04_s02) — 화면에 코드를 내지 않는다.
//     111 로 섞여 들어간 옛 의상 구매는 그 키(outfit/skin)로 「의상 구매」를 되찾는다.
//   ★새 행 memo 는 「캐릭터 · 의상」. 서버(Hades)가 앞에 locker: 를 붙여 남기는 동안은 그 접두사만 떼고 보여 준다.

const INTERNAL_KEY = /^(slot|outfit|character|skin):/;

function cleanMemo(item)
{
    let m = (item && typeof item.memo === 'string') ? item.memo.trim() : '';
    const prefixed = m.startsWith('locker:');
    if (prefixed) m = m.substring(7);
    const km = INTERNAL_KEY.exec(m);
    if (km) return { memo: '', legacyKind: km[1] };
    if (prefixed && item.fcType == 110) return { memo: '', legacyKind: null };   // 구 로커 locker:<itemId>
    return { memo: m, legacyKind: null };
}

export function pointTitle(item)
{
    const earn = item.action == 1;
    const { memo, legacyKind } = cleanMemo(item);
    switch (Number(item.fcType)) {
        case 0:   return memo ? memo : (earn ? '이벤트 적립' : '이벤트 차감');
        case 1:   return earn ? '러닝 적립' : '러닝 포인트 차감';
        case 2:   return earn ? '사이클 적립' : '사이클 포인트 차감';
        case 3:   return earn ? '웨이트 적립' : '웨이트 포인트 차감';
        case 4:   return '일립티컬 적립';
        case 5:   return '스텝퍼 적립';
        case 6:   return '스텝밀 적립';
        case 7:   return '로잉 적립';
        case 100: return '클럽 등록 적립';
        case 101: return '출석 적립';
        case 102: return earn ? '회원권 적립' : '회원권 결제';
        case 103: return earn ? '락커 적립' : '락커 결제';
        case 104: return earn ? '상품 적립' : '상품 구매';
        case 105: return '적립 취소';
        case 106: return '첫 결제 적립';
        case 110: return earn ? '꾸미기 환불' : '꾸미기 구매';
        case 111:
            if (legacyKind === 'outfit' || legacyKind === 'skin') return earn ? '의상 환불' : '의상 구매';
            return earn ? '캐릭터 환불' : '캐릭터 구매';
        case 112: return earn ? '의상 환불' : '의상 구매';
        case 500: return earn ? '포인트 받음' : '포인트 보냄';
        default:  return earn ? '포인트 적립' : '포인트 사용';
    }
}

// 보조 줄 — 제목에 메모를 쓴 이벤트(0)는 비운다. 내부 키는 빼고.
export function pointMemo(item)
{
    if (Number(item.fcType) === 0) return '';
    return cleanMemo(item).memo;
}
